module.exports = __webpack_public_path__ + "static/media/noWidgets.ea5a09dd.svg";